<template>
  <div>
    <div class="mall">
      <div class="zz-page shop-page">
        <div class="page-content-new flex-box-div">
          <otherHeaderTop
            headerTitle="商城"
            :showBack="true"
            @back="back"
          ></otherHeaderTop>

          <div
            class="shop-page-content"
            :style="{ paddingTop: safe_top + 'px' }"
          >
            <div class="page-inner">
              <div class="goods-content-wrap-new">
                <div class="top-box">
                  <div
                    class="tab-box"
                    id="tab-box"
                    @mousedown="onMouseDown"
                    @mousemove="onMouseMove"
                    @mouseup="onMouseUp"
                  >
                    <div
                      @click="handleCategory(item)"
                      :class="[
                        queryParams.category == Object.values(item)[0]
                          ? 'active'
                          : '',
                      ]"
                      class="tab-item"
                      v-for="(item, index) in categoryList"
                      :key="index"
                    >
                      {{ Object.keys(item)[0] }}
                    </div>
                  </div>
                  <div class="goods-filter-wrap">
                    <div class="jewelry-filter-wrap">
                      <div class="left-sort-box">
                        <div id="filter-box" class="filter-box fl">
                          <el-dropdown
                            trigger="click"
                            class="filter-btn"
                            @command="handleType"
                          >
                            <span class="el-dropdown-link">
                              <div class="text">{{ selected }}</div>
                              <div class="right-icon">
                                <!-- <img src="../../assets/images/line5.png" alt="" class="line" /> -->
                                <img
                                  src="../../assets/images/bottom-icon.png"
                                  alt=""
                                  class="arrow-icon"
                                />
                              </div>
                            </span>
                            <el-dropdown-menu slot="dropdown" class="sort-list">
                              <el-dropdown-item command="0"
                                >综合排序</el-dropdown-item
                              >
                              <el-dropdown-item command="1"
                                >价格升序</el-dropdown-item
                              >
                              <el-dropdown-item command="2"
                                >价格降序</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <div
                        class="left-filter1"
                        @click="isExchange = !isExchange"
                      >
                        <!-- <div
                        class="check"
                        :class="[isExchange ? 'active' : '']"
                      ></div> -->
                        <!-- <div class="text">可兑换</div> -->
                      </div>
                      <div class="right-search-box">
                        <div class="search-input">
                          <input
                            v-model="queryParams.name"
                            type="text"
                            placeholder="输入道具名称"
                          />
                        </div>
                        <div class="search-btn" @click="searchSkins()">
                          <img
                            src="../../assets/images/search-icon.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex-list">
                  <!-- <div class="img-layer2"></div> -->
                  <div
                    class="flex-inner"
                    @scrolltolower="getLists"
                    :scroll-y="true"
                  >
                    <div role="feed" class="van-list">
                      <div class="goods-list-content" @scroll="scrollEventFn">
                        <div
                          class="goods-item"
                          :class="[item.selected ? 'item-sel' : '']"
                          @click="selectGoods(item)"
                          v-for="(item, index) in shoplist"
                          :key="index"
                        >
                          <div class="jinbi">
                            <img
                              src="@/assets/home/jinbi.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <span>{{ item.usePrice }}</span>
                          </div>
                          <div class="goods-img">
                            <img
                              :src="item.imageUrl"
                              alt=""
                              style="height: 100%; width: 100%"
                              mode="aspectFit"
                            />
                          </div>
                          <div class="prod-info">
                            <p class="prod-name text-ellipsis">
                              {{ item.shortName }}
                            </p>
                            <p class="wear">{{ item.exteriorName }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="shoplist.length == 0"
                      style="width: 100%; margin-top: 30%"
                    >
                      <div class="no-data">
                        <div class="empty-box-new"></div>
                        <div class="tip-text">暂无商品</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="shop-bottom-bar-wrap">
                  <div class="cat-box" @click="showCart">
                    <div class="cat-icon">
                      <div class="cat-num-box" v-if="selectLists.length > 0">
                        {{ selectLists.length }}
                      </div>
                    </div>
                  </div>
                  <div class="total-price">
                    <image
                      src="@/assets/home/jinbi.png"
                      alt=""
                      class="bi-icon"
                    ></image>
                    <div class="price-num">{{ totalAmount }}</div>
                  </div>
                  <div class="buy-btn" @click="handleExchange">
                    <span> 兑 换 </span>
                  </div>
                </div>
                <!----><!---->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <u-picker
        :show="showSort"
        :columns="sortLists"
        keyName="name"
        :closeOnClickOverlay="true"
        @close="showSort = false"
        @cancel="showSort = false"
        @confirm="changeSort"
      ></u-picker>
      <u-notify ref="uNotify" message=""></u-notify>
      <uni-popup ref="cartBox" type="bottom">
        <div class="goods-content-wrap-new" style="height: 98.67 * 4.2px">
          <div class="car-sel-box van-popup--bottom">
            <div class="popup-top-total-wrap">
              <div class="car-num">
                <div class="pre-img"></div>
                <div class="num">已选{{ selectLists.length }}件</div>
              </div>
              <div class="folder" @click="closeCartBox()"></div>
              <div class="cancel-btn" @click="clearAllSelect">全部取消</div>
            </div>
            <div
              class="cat-list-wrap"
              style="padding-bottom: 100rpx; height: 100%"
            >
              <div
                class="goods-item"
                v-for="(item, index) in selectLists"
                :key="index"
              >
                <div class="goods-img">
                  <div
                    class="stock-nums"
                    style="display: flex; align-items: center; z-index: 99"
                  >
                  
                  </div>
                  <image :src="item.imageUrl" mode="aspectFit"></image>
                </div>
                <div class="goods-info">
                  <div class="goods-name">{{ item.itemName }}</div>
                  <div class="goods-price">
                    <image
                      src="../../assets/images/pi.png"
                      class="bi-icon"
                    ></image>
                    <div>{{ item.price }}</div>
                  </div>
                 
                </div>
                <div
                  class="delete-item"
                  @click="delSelectLists(item, index)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </uni-popup> -->
    </div>
  </div>
</template>

<script>
import otherHeaderTop from "@/components/otherHeaderTop.vue";
import {
  shoplist,
  shopconvert,
  shopcondition,
  getArticle,
  getUserInfo,
} from "@/api/index";
export default {
  components: { otherHeaderTop },
  data() {
    return {
      isOver: "加载中",
      queryParams: {
        sortBy: null,
        maxPrice: null,
        minPrice: null,
        quality: null,
        type: null,
        pageSize: 15,
        pageNum: 1,
        category: "",
      },
      iscategory: false,
      isworth: false,
      isPrice: true,
      qualityList: [],
      categoryList: [],
      category: "类别",
      isOpen: false,
      isquality: false,
      quality: "品质",
      pz_s: false,
      type: "综合排序",
      type_s: "zhpx",
      istype: false,
      // shoplist: [],
      item: {},
      total: 0,
      shoplist: [],
      event: null,
      // /--------//
      safe_top: 0,
      isExchange: false,
      showSort: false,
      sortLists: [
        [
          {
            name: "价格高低排序",
            order: "desc",
          },
          {
            name: "价格低高排序",
            order: "asc",
          },
        ],
      ],
      page: 1,
      limit: 20,
      lists: [],
      // isOver: false,
      cates: [],
      user: {},
      selectLists: [],
      cateId: 0,
      order: "",
      orderInfo: "价格高低排序",
      keyword: "",
      totalAmount: "0.00",
      isDragging: false,
      startX: 0,
      selected: "综合排序",
    };
  },
  created() {
    this.getShopList();
    // 查询分类
    this.getShopCondition();
    window.addEventListener("popstate", () => {
      if (this.isOpen) {
        this.isOpen = false;
      }
    });
  },
  methods: {
    selectGoods(item) {
      if (this.selectLists.length >= 1 && !item.selected) {
        this.$message({
          duration: 1000,
          message: "一次只能兑换一个商品",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      item.selected = item.selected ? false : true;

      if (item.selected) {
        item.number = 1;
        this.selectLists.push(item);
      } else {
        this.selectLists.forEach((itm, index) => {
          if (itm.id == item.id) {
            this.selectLists.splice(index, 1);
          }
        });
      }
      this.calcSelectGoods();
      this.$forceUpdate();
    },
    calcSelectGoods() {
      let totalAmount = 0;
      this.selectLists.forEach((itm) => {
        totalAmount =
          parseFloat(totalAmount) + parseFloat(itm.usePrice) * itm.number;
      });
      this.totalAmount = totalAmount.toFixed(2);
    },
    back() {
      // 返回上一级
      this.$router.go(-1);
    },
    onMouseDown(event) {
      this.isDragging = true;
      this.startX = event.clientX;
    },
    onMouseMove(event) {
      if (this.isDragging) {
        const moveX = event.clientX - this.startX;
        const container = document.getElementById("tab-box");
        container.scrollLeft -= moveX;
        this.startX = event.clientX;
      }
    },
    onMouseUp() {
      this.isDragging = false;
    },
    changeCate() {},
    getLists() {},
    showCart() {},
    refresh() {},
    exchange() {},
    changeSort() {},
    delSelectLists() {},
    // 旧的
    playAudio() {
      this.$store.commit("playAudio");
    },
    handleilltate() {
      this.$bus.$emit("is_illustrate", true);
      setTimeout(() => {
        getArticle("shop").then((res) => {
          let dream = res.data.data.contentList[0].content;
          this.$bus.$emit("nr_illustrate", dream);
        });
      }, 500);
    },
    scrollEventFn(event) {
      const container = event.target;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        console.log(this.isOver, "23232");
        if (this.isOver == "加载中") {
          this.queryParams.pageNum++;
          setTimeout(() => {
            this.getShopList();
          }, 5);
        } else {
          this.$message({
            duration: 1000,
            message: "暂无更多数据",
            type: "warning",
            customClass: "log_warning",
          });
        }
      }
    },
    handleWorth(res) {
      if (res == 2) {
        this.isworth = false;
        this.getShopList();
      } else if (res == 1) {
        this.isworth = false;
        this.queryParams.maxPrice = null;
        this.queryParams.minPrice = null;
      }
    },
    handleExchange() {
      let obj = { ornamentsId: this.selectLists[0].id };
      shopconvert(obj).then((res) => {
        getUserInfo().then((res) => {
          this.$store.commit("USER_INFO", res.data.data);
        });
        if (res.data.code == 200) {
          this.$message({
            duration: 1000,
            message: "兑换成功",
            type: "success",
            customClass: "log_success",
          });
        } else {
          this.$message({
            duration: 1000,
            message: res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
    },
    handleClose() {
      this.isOpen = false;
      this.$router.back();
    },
    handleOpen(res) {
      this.list = {};
      this.isOpen = true;
      const state = { title: "title", url: "#" };
      window.history.pushState(state, state.title, state.url);
      this.list = res;
    },
    handleCategory(res) {
      this.isOver = "加载中";
      this.queryParams.pageNum = 1;
      this.shoplist = [];
      if (this.event) {
        this.event.srcElement.scrollTop = 0;
      }
      this.queryParams.type = Object.values(res)[0];
      this.getShopList();
      this.iscategory = false;
      this.queryParams.category = Object.values(res)[0];
    },
    handleQuality(res) {
      this.queryParams.pageSize = 15;
      if (this.event) {
        this.event.srcElement.scrollTop = 0;
      }

      // console.log(res);
      this.queryParams.quality = Object.values(res)[0];
      this.getShopList();
      this.isquality = false;
      if (Object.keys(res)[0] == "默认") {
        this.quality = "品质";
      } else {
        this.quality = Object.keys(res)[0];
      }
      // console.log('quality',this.quality);
    },

    handleType(res) {
      if (res == "0") {
        this.selected = "综合排序";
        this.queryParams.sortBy = null;
      } else if (res == "1") {
        this.selected = "价格升序";
        this.queryParams.sortBy = 1;
      } else if (res == "2") {
        this.selected = "价格降序";
        this.queryParams.sortBy = 2;
      }
      this.isOver = "加载中";
      this.queryParams.pageNum = 1;
      this.shoplist = [];
      this.getShopList();
    },
    handleback() {
      alert("1");
    },
    getShopList() {
      shoplist(this.queryParams).then((res) => {
        let lists = [];
        lists = res.data.rows;
        this.shoplist.push(...lists);
        // this.total = res.data.total;
        if (res.data.rows.length < this.queryParams.pageSize) {
          this.isOver = "暂无更多";
        }
      });
    },
    getShopCondition() {
      shopcondition(0).then((res) => {
        this.categoryList = res.data.data;
        this.categoryList.unshift({ 全部: "" });
      });
      // shopcondition(3).then((res) => {
      //   this.qualityList = res.data.data;
      //   this.qualityList.push({ 默认: "" });
      //   console.log("qualityList", this.qualityList);
      // });
    },
    searchSkins() {
      this.isOver = "加载中";
      this.queryParams.pageNum = 1;
      this.shoplist = [];
      this.getShopList();
    },
  },
  watch: {
    istype(newValue) {
      if (newValue) {
        this.iscategory = false;
        this.isquality = false;
      }
    },
    iscategory(newValue) {
      if (newValue) {
        this.istype = false;
        this.isquality = false;
      }
    },
    isquality(newValue) {
      if (newValue) {
        this.iscategory = false;
        this.istype = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 新的代码
@import "../../assets/style/header.scss";

.page-content-new {
  z-index: unset;
}

.mall {
  --head-height: 14 * 4.2px;
}

.shop-page .shop-page-content {
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  position: relative;
  width: 100%;
  height: 100vh;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 4.5rem;
}

.shop-page .shop-page-content .page-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.goods-content-wrap-new {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  /*条件筛选popup*/
}

.goods-content-wrap-new .top-box {
  height: 26.64 * 4.2px;
}

.goods-content-wrap-new .top-box .tab-box {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 17.87 * 4.2px;
  margin: -1.73 * 4.2px 0 0;
  padding-left: 5.73 * 4.2px;
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/shop_bg5.png");
  overflow-x: scroll;
  overflow-y: hidden;
}

.goods-content-wrap-new .top-box .tab-box::-webkit-scrollbar {
  height: 2px;
  background-color: unset !important;
}

.goods-content-wrap-new .top-box .tab-box::-webkit-scrollbar-thumb {
  background-color: unset !important;
}

.goods-content-wrap-new .top-box .tab-box::-webkit-scrollbar-track {
  background-color: unset !important;
}

.goods-content-wrap-new .top-box .tab-box .tab-item {
  width: 18.26 * 4.2px;
  height: 7.28 * 4.2px;
  line-height: 7.28 * 4.2px;
  text-align: center;
  margin: 6 * 4.2px 0 0 0;
  background-size: 100% 100%;
  background-image: url("../../assets/image3/share/notSelectedBack.png");
  flex-shrink: 0;
  font-size: 3.33 * 4.2px;
  // cursor: move;
}

.goods-content-wrap-new .top-box .tab-box .tab-item.active {
  background-image: url("../../assets/image3/share/selectBack.png");
}

.goods-content-wrap-new .goods-filter-wrap {
  width: 100%;
  height: 8.53 * 4.2px;
}

.goods-content-wrap-new .goods-filter-wrap .search-box {
  width: 92 * 4.2px;
  height: 7.87 * 4.2px;
  background-size: 100% 100%;
}

.goods-content-wrap-new .goods-filter-wrap .search-box .search-left {
  display: inline-block;
}

.goods-content-wrap-new .goods-filter-wrap .search-box .search-input {
  width: 58.67 * 4.2px;
  height: 8.27 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  color: #717da9;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 2.93 * 4.2px;
}

.goods-content-wrap-new .goods-filter-wrap .search-box .search-input .line {
  margin: 0 1.33 * 4.2px;
  height: 8.27 * 4.2px;
  line-height: 8.27 * 4.2px;
}

.goods-content-wrap-new
  .goods-filter-wrap
  .search-box
  .search-input
  .number-input {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.goods-content-wrap-new
  .goods-filter-wrap
  .search-box
  .search-input
  .number-input
  input {
  width: 100%;
  height: 80%;
  text-indent: 1.07 * 4.2px;
  background: transparent;
  text-align: center;
}

.goods-content-wrap-new .goods-filter-wrap .search-box .search-btn {
  float: right;
  width: 4.05 * 4.2px;
  height: 4.05 * 4.2px;
  background-size: 100% 100%;
}

.goods-content-wrap-new .goods-filter-wrap .search-box .search-btn .text {
  font-size: 3.2 * 4.2px;
  font-weight: 700;
}

.goods-content-wrap-new
  .goods-filter-wrap
  .search-box
  .search-btn
  .text::before {
  float: left;
  display: inline-block;
  width: 2.93 * 4.2px;
  height: 2.93 * 4.2px;
  margin: 0.67 * 4.2px 0.93 * 4.2px 0 0;
  content: "";
  background-size: 100% 100%;
}

.goods-content-wrap-new .goods-filter-wrap .sort-wrap {
  position: relative;
  height: 6.67 * 4.2px;
  margin: 4 * 4.2px 0 0;
}

.goods-content-wrap-new .goods-filter-wrap .sort-wrap .sort-item {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 29.73 * 4.2px;
  height: 6.67 * 4.2px;
  line-height: 6.67 * 4.2px;
  margin-right: 1.33 * 4.2px;
  text-align: center;
  font-size: 2.93 * 4.2px;
  border: 1px solid #b4afd8;
  color: #7b77a8;
  background-color: #f5f5f5;
}

.goods-content-wrap-new .goods-filter-wrap .sort-wrap .sort-item.active {
  color: #ffffff;
  background-size: 100% 100%;
  border: none;
}

.goods-content-wrap-new .jewelry-filter-wrap {
  height: 8.53 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // margin: 2 * 4.2px 0 4 * 4.2px 0;
  padding: 0 5.67 * 4.2px 0 3 * 4.2px;
  display: flex;
  justify-content: space-between;
}

.goods-content-wrap-new .left-sort-box .custom-select-box {
  position: relative;
  float: right;
  width: 42 * 4.2px;
  height: 8 * 4.2px;
  background-image: url("../../assets/images/k2.png");
  background-size: 100% 100%;
  color: #fffefe;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-selection {
  height: 8 * 4.2px;
  background: transparent;
  border: none;
  -webkit-border-radius: 0;
  border-radius: 0;
  color: #a6bbff;
}

.ivu-select-selected-value {
  height: 8.53 * 4.2px;
  line-height: 8.53 * 4.2px;
  font-size: 3.2 * 4.2px !important;
  color: #fffefe;
  padding-left: 3.33 * 4.2px;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-selection
  .ivu-select-arrow {
  font-size: 4.27 * 4.2px;
  right: 2 * 4.2px;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-selection
  .ivu-select-placeholder {
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box.ivu-select-visible
  .ivu-select-selection {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.goods-content-wrap-new .left-sort-box .custom-select-box .ivu-select-dropdown {
  width: 37.33 * 4.2px;
  min-height: 16 * 4.2px;
  background-color: #c9d5e5;
  -webkit-border-radius: 0;
  border-radius: 0;
  padding: 0;
  top: 6.93 * 4.2px;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-dropdown
  .ivu-select-item {
  width: 37.33 * 4.2px;
  height: 8.53 * 4.2px;
  line-height: 6.67 * 4.2px;
  background: #c9d5e5;
  font-size: 3.2 * 4.2px !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-dropdown
  .ivu-select-item.ivu-select-item-selected {
  background-color: #92a1be;
  color: #202633;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-dropdown
  .ivu-select-item.ivu-select-item-focus {
  background-color: #92a1be;
  color: #202633;
}

.goods-content-wrap-new
  .left-sort-box
  .custom-select-box
  .ivu-select-dropdown
  .ivu-select-item:hover {
  background-color: #92a1be;
}

.goods-content-wrap-new .left-filter1 {
  float: left;
  height: 8.53 * 4.2px;
  line-height: 8.53 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #ffffff;
  margin-left: 3.47 * 4.2px;
}

.goods-content-wrap-new .left-filter1 .check {
  float: left;
  display: inline-block;
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
  margin: 1.33 * 4.2px 0 0;
  background: url("../../assets/images/dot.png") no-repeat center center / 100%
    100%;
}

.goods-content-wrap-new .left-filter1 .check.active {
  background: url("../../assets/images/dot.png") no-repeat center center / 100%
      100%,
    url("../../assets/images/right-icon.png") no-repeat center center / 15.666px
      9.534px;
}

.goods-content-wrap-new .left-filter1 .text {
  float: left;
  margin-left: 1.33 * 4.2px;
  color: #a6bbff;
}

.goods-content-wrap-new .right-search-box {
  width: 42 * 4.2px;
  height: 8 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  line-height: 8 * 4.2px;
  // float: right;
  background-size: 100% 100%;
  background-image: url("../../assets/image3/home/sortBack.png");
  padding: 0 15px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.goods-content-wrap-new .right-search-box input {
  width: 35 * 4.2px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-indent: 1.33 * 4.2px;
  background: transparent;
  color: #ecf0f9;
}

.goods-content-wrap-new .right-search-box input::-webkit-input-placeholder {
  color: #859fc0;
}

.goods-content-wrap-new .right-search-box input::-moz-placeholder {
  color: #859fc0;
}

.goods-content-wrap-new .right-search-box input::-ms-input-placeholder {
  color: #859fc0;
}

.goods-content-wrap-new .right-search-box input::placeholder {
  color: #859fc0;
}

.goods-content-wrap-new .right-search-box .search-btn {
  width: 4.05 * 4.2px;
  height: 4.05 * 4.2px;
}

.goods-content-wrap-new .right-search-box .search-btn img {
  float: right;
  width: 4.05 * 4.2px;
  height: 4.05 * 4.2px;
  margin: 2 * 4.2px 3 * 4.2px 0 0;
}

.goods-content-wrap-new .filter-popup-box {
  background: none !important;
}

.goods-content-wrap-new .filter-popup-box .statistics-filter-popup-box-content {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.goods-content-wrap-new .filter-popup-box .filter-popup-box-content {
  width: 100%;
  height: 100%;
  background-size: 10.67 * 4.2px 16 * 4.2px;
  padding: 6.67 * 4.2px 2.67 * 4.2px 2.67 * 4.2px 2.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-popup-box-bottom-bg {
  width: 78.67 * 4.2px;
  height: 80 * 4.2px;
  background-size: cover;
  position: absolute;
  left: 0;
  bottom: 0;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .clear-price-text {
  position: absolute;
  right: 0;
  top: 0;
  color: #ff783c;
  font-size: 3.47 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .select-type-text {
  width: 100%;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;
  color: #3c3855;
  font-size: 4.27 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap {
  width: 100%;
  height: 8.67 * 4.2px;
  padding-bottom: 1.6 * 4.2px;
  padding-top: 2.4 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-input {
  width: 31.33 * 4.2px;
  height: 8.67 * 4.2px;
  line-height: 8.8 * 4.2px;
  font-size: 3.47 * 4.2px;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1px solid #b4afd8;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-input
  input {
  width: 100%;
  height: 100%;
  text-align: center;
  background: transparent;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-input
  input::-webkit-input-placeholder {
  color: #cfcfcf;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-input
  input::-moz-placeholder {
  color: #cfcfcf;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-input
  input::-ms-input-placeholder {
  color: #cfcfcf;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-input
  input::placeholder {
  color: #cfcfcf;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-range-line {
  width: 10.67 * 4.2px;
  height: 100%;
  position: relative;
  float: left;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .price-input-wrap
  .price-range-line::after {
  content: "";
  display: block;
  position: absolute;
  width: 4 * 4.2px;
  border-bottom: 1px solid #6b69ac;
  left: 3.33 * 4.2px;
  top: 4.33 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .select-content {
  width: 100%;
  overflow: hidden;
  padding-top: 2.4 * 4.2px;
  margin-bottom: 4 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .filter-select-item {
  width: 23.33 * 4.2px;
  height: 8.67 * 4.2px;
  border: 1px solid #b4afd8;
  background: rgba(255, 255, 255, 0.5);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  float: left;
  margin-right: 1.6 * 4.2px;
  margin-bottom: 4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.47 * 4.2px;
  color: #7b77a8;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .filter-select-item.active {
  border: none;
  background-size: cover;
  color: #ffffff;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .filter-select-item:nth-of-type(3n) {
  margin-right: 0;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-select-box
  .filter-select-item
  .middle-line {
  margin: -0.27 * 4.2px 0.67 * 4.2px 0 0.67 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .select-price-cache {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 50;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .select-price-cache
  .cache-item {
  width: 22.67 * 4.2px;
  height: 8.67 * 4.2px;
  background-color: #dddddd;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  float: left;
  margin-right: 1.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 3.47 * 4.2px;
  color: #7b77a8;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-opt-btn {
  width: 100%;
  overflow: hidden;
  height: 8.27 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 5.33 * 4.2px;
  position: relative;
  z-index: 2;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-opt-btn
  .opt-btn {
  display: block;
  width: 30.27 * 4.2px;
  height: 8.27 * 4.2px;
  color: #ffffff;
  font-size: 3.47 * 4.2px;
  line-height: 8.27 * 4.2px;
  text-align: center;
  margin: 0 3.07 * 4.2px;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-opt-btn
  .opt-btn:active {
  opacity: 0.85;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-opt-btn
  .submit-btn {
  background-size: cover;
}

.goods-content-wrap-new
  .filter-popup-box
  .filter-popup-box-content
  .filter-opt-btn
  .cancel-btn {
  background-size: cover;
}

.goods-content-wrap-new .custom-page-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.goods-content-wrap-new .van-overlay {
  z-index: 2000 !important;
}

.goods-content-wrap-new .van-popup--bottom {
  z-index: 2002 !important;
  background: transparent;
  overflow-y: visible;
}

.goods-content-wrap-new .van-popup--bottom .cat-list-wrap {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  overflow-y: auto;
  margin-top: 2 * 4.2px;
}

.goods-content-wrap-new .van-popup--bottom .cat-list-wrap .goods-item {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 88.27 * 4.2px;
  height: 21.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  background-image: url("../../assets/images/shop_bg777.png");
  background-size: 100% 100%;
  margin: 0 4 * 4.2px 3.33 * 4.2px 5.87 * 4.2px;
  color: #fff;
}

.goods-content-wrap-new .van-popup--bottom .cat-list-wrap .goods-item .del-ic {
  position: absolute;
  z-index: 10;
  top: 1.33 * 4.2px;
  right: 15.12px;
  width: 4 * 4.2px;
  height: 4 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item:last-child {
  border: none;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-img {
  float: left;
  position: relative;
  width: 18.27 * 4.2px;
  height: 12.8 * 4.2px;
  margin: 4.4 * 4.2px 0 0 2.4 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-img
  .stock-num {
  position: absolute;
  left: -0.8 * 4.2px;
  bottom: -0.27 * 4.2px;
  width: 14.27 * 4.2px;
  height: 5.07 * 4.2px;
  background-image: url("../../assets/images/k28.png");
  background-size: 100% 100%;
  font-size: 3.2 * 4.2px;
  color: #ecf0f9;
  padding-left: 1.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-img
  .stock-num
  .pre {
  display: inline-block;
  width: 4.8 * 4.2px;
  text-align: center;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-img
  .stock-num
  .num {
  width: 6.67 * 4.2px;
  text-align: center;
  padding-left: 0.67 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-img
  image {
  width: 100%;
  height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 70.67 * 4.2px;
  padding: 2.67 * 4.2px 2.67 * 4.2px 2.13 * 4.2px 2.8 * 4.2px;
  font-size: 3.2 * 4.2px;
  font-weight: 500;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .goods-name {
  width: 43.2 * 4.2px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 3.2 * 4.2px;
  margin-top: 1.6 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .goods-price {
  width: 26.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 4 * 4.2px;
  font-weight: 700;
  margin-top: 2.67 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .goods-price
  .bi-icon {
  width: 5.07 * 4.2px;
  height: 5.07 * 4.2px;
  margin-right: 1.6 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .number-box-wrap {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  right: 1.33 * 4.2px;
  bottom: 2.67 * 4.2px;
  width: 24 * 4.2px;
  height: 5.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-size: 21.33 * 4.2px 5.33 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .number-box-wrap
  .btn {
  width: 5.73 * 4.2px;
  height: 5.33 * 4.2px;
  line-height: 5.33 * 4.2px;
  font-size: 4 * 4.2px;
  text-align: center;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .number-box-wrap
  .btn:active {
  opacity: 0.8;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .number-box-wrap
  .reduce-btn {
  float: left;
  width: 3.73 * 4.2px;
  height: 3.73 * 4.2px;
  margin-left: 2 * 4.2px;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("../../assets/images/k29.png");
  background-size: 3.73 * 4.2px 1.07 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .number-box-wrap
  .add-btn {
  float: right;
  width: 3.73 * 4.2px;
  height: 3.73 * 4.2px;
  margin-right: 2 * 4.2px;
  background-image: url("../../assets/images/plus-icon.png");
  background-size: 3.73 * 4.2px 3.73 * 4.2px;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .goods-info
  .number-box-wrap
  .number-text {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
  color: #c9d5e5;
  font-size: 4 * 4.2px;
  font-weight: 700;
}

.goods-content-wrap-new
  .van-popup--bottom
  .cat-list-wrap
  .goods-item
  .delete-item {
  position: absolute;
  top: 0;
  right: 0;
  width: 10.13 * 4.2px;
  height: 4.8 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/close-bg.png");
}

.goods-content-wrap-new .car-sel-box {
  bottom: 25.47 * 4.2px;
  height: 100%;
  color: #c9d5e5;
  background-size: 100% 100%;
  // background-image: url("../../assets/images/shop_bg8.png");
  position: relative;
}

.goods-content-wrap-new .popup-top-total-wrap {
  position: relative;
  height: 14.13 * 4.2px;
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 88 * 4.2px 2 * 4.2px;
  background-image: url("../../assets/images/line9.png");
}

.goods-content-wrap-new .popup-top-total-wrap .car-num {
  display: inline-block;
  height: 6.4 * 4.2px;
  margin: 9.534px 0 0 6.27 * 4.2px;
}

.goods-content-wrap-new .popup-top-total-wrap .car-num .pre-img {
  float: left;
  width: 8.13 * 4.2px;
  height: 6.4 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/cart-icon.png");
}

.goods-content-wrap-new .popup-top-total-wrap .car-num .num {
  float: left;
  width: 26.67 * 4.2px;
  height: 6.4 * 4.2px;
  line-height: 6.4 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #fff;
  margin-left: 2.8 * 4.2px;
}

.goods-content-wrap-new .popup-top-total-wrap .folder {
  position: absolute;
  top: 0;
  left: 45.87 * 4.2px;
  width: 8.27 * 4.2px;
  height: 6.13 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/down-icon.png");
}

.goods-content-wrap-new .popup-top-total-wrap .cancel-btn {
  float: right;
  width: 20 * 4.2px;
  height: 7 * 4.2px;
  line-height: 7 * 4.2px;
  text-align: center;
  font-size: 2.67 * 4.2px;
  margin: 3.13 * 4.2px 5.87 * 4.2px 0 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/s_commit_btn.png");
}

.goods-content-wrap-new .flex-list {
  position: relative;
  height: 78vh;
  width: 100%;
}

.goods-content-wrap-new .flex-list .img-layer2 {
  z-index: 16;
  position: absolute;
  bottom: -0.4 * 4.2px;
  left: 0;
  right: 0;
  height: 5.47 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/box_bg_7.png");
}

.flex-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // overflow-y: scroll;
  // overflow-x: hidden;
}

.flex-inner::-webkit-scrollbar {
  width: 0.67 * 4.2px;
  height: 0.67 * 4.2px;
}

.flex-inner::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
}

.goods-content-wrap-new .goods-list-content {
  width: 100%;
  height: calc(100vh - 300px);
  overflow-y: scroll;
  padding: 2.86 * 4.2px 4.76 * 4.2px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
  margin-left: 1.19 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 100vw;
    padding: 2.86vw 4.76vw;
    margin-left: 1.19vw;
  }
}

.goods-content-wrap-new .goods-list-content .goods-item {
  position: relative;
  // display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 27 * 4.2px;
  height: 35.5 * 4.2px;
  font-size: 2.31 * 4.2px;
  background: url("~@/assets/knapsack/7.png") no-repeat 0 0;
  background-size: 100% 100%;
  padding: 1.9 * 4.2px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  color: #e5c7ff;
  margin: 0 3 * 4.2px 3 * 4.2px 0;

  @media only screen and (max-width: 430px) {
    width: 27vw;
    height: 35.5vw;
    margin: 0 3vw 3vw 0;
    padding: 1.9vw;
    font-size: 2.38vw;
  }
}

.goods-content-wrap-new .goods-list-content .goods-item .jinbi {
  display: flex;
  align-items: center;
  font-style: normal;
  text-transform: none;
  margin-bottom: 4px;

  span {
    margin-left: 4px;
  }
}

.goods-content-wrap-new .goods-list-content .goods-item .goods-img {
  width: 100%;
  height: 20 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 20vw;
  }
}

.goods-content-wrap-new .goods-list-content .goods-item .prod-info {
  margin-top: 3px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    margin-top: 0.71vw;
  }

  .prod-name {
    margin-bottom: 2px;
  }
}

.goods-content-wrap-new .goods-list-content .goods-item:nth-child(3n) {
  margin-right: 0 !important;
}

.goods-content-wrap-new .goods-list-content .goods-item.item-sel {
  background: url("~@/assets/knapsack/7-1.png") no-repeat 0 0;
  background-size: 100% 100%;
}

.goods-content-wrap-new .goods-list-content .goods-item.item-sel .wear-degree {
  color: #ffffff;
}

.goods-content-wrap-new .goods-list-content .goods-item .wear-degree {
  position: absolute;
  top: 9.33 * 4.2px;
  left: 2.67 * 4.2px;
  color: #3bf4ff;
  font-size: 2.67 * 4.2px;
}

.goods-content-wrap-new .goods-list-content .goods-item .name {
  position: absolute;
  bottom: 10.4 * 4.2px;
  left: 0;
  width: 100%;
  height: 4 * 4.2px;
  font-size: 2.67 * 4.2px;
  text-align: left;
  padding: 0 2 * 4.2px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.goods-content-wrap-new .goods-list-content .goods-item .bottom-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 10 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #edc79e;
}

.goods-content-wrap-new .goods-list-content .goods-item .bottom-info .price {
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 1.73 * 4.2px 0 0 0;
}

.goods-content-wrap-new
  .goods-list-content
  .goods-item
  .bottom-info
  .price
  .icon {
  width: 4.27 * 4.2px;
  height: 4.27 * 4.2px;
  margin-right: 0.67 * 4.2px;
}

.goods-content-wrap-new .goods-list-content .goods-item .copy-ic {
  position: absolute;
  top: 1.33 * 4.2px;
  right: 2 * 4.2px;
  width: 4.27 * 4.2px;
  height: 4.53 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/copy1-icon.png");
}

.goods-content-wrap-new .goods-list-content .goods-item .check-img {
  position: absolute;
  top: 1.33 * 4.2px;
  left: 1.33 * 4.2px;
  width: 3.2 * 4.2px;
  height: 3.2 * 4.2px;
}

.goods-content-wrap-new .goods-list-content .empty {
  color: #828282;
  text-align: center;
  padding-top: 26.67 * 4.2px;
}

.goods-content-wrap-new .cat-box {
  position: relative;
  float: left;
  margin: 7.47 * 4.2px 0 0 5.87 * 4.2px;
}

.goods-content-wrap-new .cat-icon {
  position: relative;
  width: 10.27 * 4.2px;
  height: 10.27 * 4.2px;
  background-size: 100% 100%;
  // background-image: url("../../assets/images/cart-active-icon.png");
  background-image: url("../../assets/image3/home/butCar.png");
}

.goods-content-wrap-new .cat-icon .cat-num-box {
  position: absolute;
  left: 6.67 * 4.2px;
  top: -1.33 * 4.2px;
  width: 5.07 * 4.2px;
  height: 5.07 * 4.2px;
  line-height: 5.07 * 4.2px;
  -webkit-border-radius: 2.53 * 4.2px;
  border-radius: 2.53 * 4.2px;
  background: #ad2531;
  text-align: center;
  font-size: 15.12px;
  color: #fff;
}

.goods-content-wrap-new .shop-bottom-bar-wrap {
  z-index: 2004;
  width: 100%;
  height: 90px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  // background-size: 100% 100%;
  // background-image: url("../../assets/images/shop_bg4.png");
  background: rgba(15, 2, 97, 0.6);
  position: relative;
  bottom: 0;
}

.goods-content-wrap-new .shop-bottom-bar-wrap .total-price {
  height: 10.67 * 4.2px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 2.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 7.07 * 4.2px 0 0 2 * 4.2px;
}

.goods-content-wrap-new .shop-bottom-bar-wrap .total-price .bi-icon {
  width: 6.27 * 4.2px;
  height: 6.27 * 4.2px;
  margin-right: 1.07 * 4.2px;
}

.goods-content-wrap-new .shop-bottom-bar-wrap .total-price .price-num {
  font-size: 4.4 * 4.2px;
  color: #dec292;
}

.goods-content-wrap-new .shop-bottom-bar-wrap .buy-btn {
  width: 42.8 * 4.2px;
  height: 12.93 * 4.2px;
  line-height: 12.93 * 4.2px;
  text-align: center;
  font-size: 4 * 4.2px;
  margin: 5.47 * 4.2px 5.87 * 4.2px 0 0;
  background-size: 100% 100%;
  background-image: url("../../assets/recharge-btn.png");
}
.goods-content-wrap-new .shop-bottom-bar-wrap .buy-btn span {
  background: linear-gradient(90deg, #ddffff 0%, #24e5ff 100%);
  -webkit-background-clip: text; /* Safari/Chrome */
  background-clip: text;
  -webkit-text-fill-color: transparent; /* 文本透明以显示背景渐变 */
  color: transparent; /* 兼容非Webkit内核浏览器 */
}

.goods-content-wrap-new .shop-bottom-bar-wrap .buy-btn:active {
  opacity: 0.9;
}

.filter-btn {
  width: 42 * 4.2px;
  height: 8 * 4.2px;
  background: url("../../assets/knapsack/1.png") no-repeat 0 0;
  background-size: 42 * 4.2px 8 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.filter-btn .el-dropdown-link {
  display: flex;
}

// 筛选
.sort-list {
  background: url("../../assets/knapsack/4.png") no-repeat;
  background-position-x: center;
  background-size: 100% 100%;
  border: none !important;
  color: #fff;

  /deep/.el-dropdown-menu__item {
    color: #fff !important;

    &:hover {
      background-color: #3a4f90 !important;
      color: #fff !important;
    }
  }

  /deep/.popper__arrow {
    border-bottom-color: #163490 !important;
  }

  /deep/.popper__arrow::after {
    border-bottom-color: #163490 !important;
  }
}

.appview {
  height: 100vh;
}

@media only screen and (max-width: 430px) {
  .goods-content-wrap-new .flex-list {
    height: 69vh;
  }

  .mall {
    --head-height: 14vw;
  }

  .goods-content-wrap-new .shop-bottom-bar-wrap {
    position: fixed;
    bottom: 0;
  }

  .goods-content-wrap-new .top-box {
    height: 26.64vw;
  }

  .goods-content-wrap-new .top-box .tab-box {
    height: 17.87vw;
    margin: -1.73vw 0 0;
    padding-left: 5.73vw;
  }

  .goods-content-wrap-new .top-box .tab-box::-webkit-scrollbar {
    height: 2px;
  }

  .goods-content-wrap-new .top-box .tab-box .tab-item {
    width: 18.26vw;
    height: 7.28vw;
    line-height: 7.28vw;
    margin: 6vw 0 0 0;
    font-size: 3.33vw;
  }

  .goods-content-wrap-new .goods-filter-wrap {
    height: 8.53vw;
  }

  .goods-content-wrap-new .goods-filter-wrap .search-box {
    width: 92vw;
    height: 7.87vw;
  }

  .goods-content-wrap-new .goods-filter-wrap .search-box .search-input {
    width: 58.67vw;
    height: 8.27vw;

    font-size: 2.93vw;
  }

  .goods-content-wrap-new .goods-filter-wrap .search-box .search-input .line {
    margin: 0 1.33vw;
    height: 8.27vw;
    line-height: 8.27vw;
  }

  .goods-content-wrap-new
    .goods-filter-wrap
    .search-box
    .search-input
    .number-input
    input {
    text-indent: 1.07vw;
  }

  .goods-content-wrap-new .goods-filter-wrap .search-box .search-btn {
    width: 4.05vw;
    height: 4.05vw;
  }

  .goods-content-wrap-new .goods-filter-wrap .search-box .search-btn .text {
    font-size: 3.2vw;
    font-weight: 700;
  }

  .goods-content-wrap-new
    .goods-filter-wrap
    .search-box
    .search-btn
    .text::before {
    width: 2.93vw;
    height: 2.93vw;
    margin: 0.67vw 0.93vw 0 0;
  }

  .goods-content-wrap-new .goods-filter-wrap .sort-wrap {
    height: 6.67vw;
    margin: 4vw 0 0;
  }

  .goods-content-wrap-new .goods-filter-wrap .sort-wrap .sort-item {
    width: 29.73vw;
    height: 6.67vw;
    line-height: 6.67vw;
    margin-right: 1.33vw;

    font-size: 2.93vw;
  }

  .goods-content-wrap-new .jewelry-filter-wrap {
    height: 8.53vw;
    // margin: 2vw 0 4vw 0;
    padding: 0 5.67vw 0 3vw;
  }

  .goods-content-wrap-new .left-sort-box .custom-select-box {
    width: 42vw;
    height: 8vw;
  }

  .goods-content-wrap-new
    .left-sort-box
    .custom-select-box
    .ivu-select-selection {
    height: 8vw;
  }

  .ivu-select-selected-value {
    height: 8.53vw;
    line-height: 8.53vw;
    font-size: 3.2vw !important;

    padding-left: 3.33vw;
  }

  .goods-content-wrap-new
    .left-sort-box
    .custom-select-box
    .ivu-select-selection
    .ivu-select-arrow {
    font-size: 4.27vw;
    right: 2vw;
  }

  .goods-content-wrap-new
    .left-sort-box
    .custom-select-box
    .ivu-select-selection
    .ivu-select-placeholder {
    height: 8.53vw;
    line-height: 8.53vw;
  }

  .goods-content-wrap-new
    .left-sort-box
    .custom-select-box
    .ivu-select-dropdown {
    width: 37.33vw;
    min-height: 16vw;

    top: 6.93vw;
  }

  .goods-content-wrap-new
    .left-sort-box
    .custom-select-box
    .ivu-select-dropdown
    .ivu-select-item {
    width: 37.33vw;
    height: 8.53vw;
    line-height: 6.67vw;

    font-size: 3.2vw !important;
  }

  .goods-content-wrap-new .left-filter1 {
    height: 8.53vw;
    line-height: 8.53vw;
    font-size: 3.33vw;

    margin-left: 3.47vw;
  }

  .goods-content-wrap-new .left-filter1 .check {
    width: 5.33vw;
    height: 5.33vw;
    margin: 1.33vw 0 0;
  }

  .goods-content-wrap-new .left-filter1 .text {
    margin-left: 1.33vw;
  }

  .goods-content-wrap-new .right-search-box {
    width: 42vw;
    height: 8vw;
    line-height: 8vw;
  }

  .goods-content-wrap-new .right-search-box input {
    width: 35vw;
    height: 8vw;
    line-height: 8vw;
    font-size: 3.33vw;
    text-indent: 1.33vw;
  }

  .goods-content-wrap-new .right-search-box .search-btn {
    width: 4.05vw;
    height: 4.05vw;
  }

  .goods-content-wrap-new .right-search-box .search-btn img {
    width: 4.05vw;
    height: 4.05vw;
    margin: 2vw 3vw 0 0;
  }

  .goods-content-wrap-new .filter-popup-box .filter-popup-box-content {
    background-size: 10.67vw 16vw;
    padding: 6.67vw 2.67vw 2.67vw 2.67vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-popup-box-bottom-bg {
    width: 78.67vw;
    height: 80vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .clear-price-text {
    font-size: 3.47vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .select-type-text {
    height: 4.27vw;
    line-height: 4.27vw;

    font-size: 4.27vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .price-input-wrap {
    width: 100%;
    height: 8.67vw;
    padding-bottom: 1.6vw;
    padding-top: 2.4vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .price-input-wrap
    .price-input {
    width: 31.33vw;
    height: 8.67vw;
    line-height: 8.8vw;
    font-size: 3.47vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .price-input-wrap
    .price-range-line {
    width: 10.67vw;
    height: 100%;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .price-input-wrap
    .price-range-line::after {
    left: 3.33vw;
    top: 4.33vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .select-content {
    padding-top: 2.4vw;
    margin-bottom: 4vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .filter-select-item {
    width: 23.33vw;
    height: 8.67vw;

    margin-right: 1.6vw;
    margin-bottom: 4vw;

    font-size: 3.47vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-select-box
    .filter-select-item
    .middle-line {
    margin: -0.27vw 0.67vw 0 0.67vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .select-price-cache
    .cache-item {
    width: 22.67vw;
    height: 8.67vw;

    margin-right: 1.6vw;

    font-size: 3.47vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-opt-btn {
    height: 8.27vw;

    padding-top: 5.33vw;
  }

  .goods-content-wrap-new
    .filter-popup-box
    .filter-popup-box-content
    .filter-opt-btn
    .opt-btn {
    width: 30.27vw;
    height: 8.27vw;

    font-size: 3.47vw;
    line-height: 8.27vw;

    margin: 0 3.07vw;
  }

  .goods-content-wrap-new .van-popup--bottom .cat-list-wrap {
    margin-top: 2vw;
  }

  .goods-content-wrap-new .van-popup--bottom .cat-list-wrap .goods-item {
    width: 88.27vw;
    height: 21.33vw;

    margin: 0 4vw 3.33vw 5.87vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .del-ic {
    top: 1.33vw;

    width: 4vw;
    height: 4vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-img
    .stock-num {
    position: absolute;
    left: -0.8vw;
    bottom: -0.27vw;
    width: 14.27vw;
    height: 5.07vw;

    font-size: 3.2vw;

    padding-left: 1.33vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-img
    .stock-num
    .pre {
    display: inline-block;
    width: 4.8vw;
    text-align: center;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-img
    .stock-num
    .num {
    width: 6.67vw;
    text-align: center;
    padding-left: 0.67vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info {
    width: 70.67vw;
    padding: 2.67vw 2.67vw 2.13vw 2.8vw;
    font-size: 3.2vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .goods-name {
    width: 43.2vw;

    font-size: 3.2vw;
    margin-top: 1.6vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .goods-price {
    width: 26.67vw;

    font-size: 4vw;
    font-weight: 700;
    margin-top: 2.67vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .goods-price
    .bi-icon {
    width: 5.07vw;
    height: 5.07vw;
    margin-right: 1.6vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .number-box-wrap {
    right: 1.33vw;
    bottom: 2.67vw;
    width: 24vw;
    height: 5.87vw;

    background-size: 21.33vw 5.33vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .number-box-wrap
    .btn {
    width: 5.73vw;
    height: 5.33vw;
    line-height: 5.33vw;
    font-size: 4vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .number-box-wrap
    .reduce-btn {
    width: 3.73vw;
    height: 3.73vw;
    margin-left: 2vw;

    background-size: 3.73vw 1.07vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .number-box-wrap
    .add-btn {
    width: 3.73vw;
    height: 3.73vw;
    margin-right: 2vw;

    background-size: 3.73vw 3.73vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .goods-info
    .number-box-wrap
    .number-text {
    font-size: 4vw;
  }

  .goods-content-wrap-new
    .van-popup--bottom
    .cat-list-wrap
    .goods-item
    .delete-item {
    width: 10.13vw;
    height: 4.8vw;
  }

  .goods-content-wrap-new .car-sel-box {
    bottom: 25.47vw;
  }

  .goods-content-wrap-new .popup-top-total-wrap {
    height: 14.13vw;

    background-size: 88vw 2vw;
  }

  .goods-content-wrap-new .popup-top-total-wrap .car-num {
    height: 6.4vw;
    margin: 9.534px 0 0 6.27vw;
  }

  .goods-content-wrap-new .popup-top-total-wrap .car-num .pre-img {
    float: left;
    width: 8.13vw;
    height: 6.4vw;
  }

  .goods-content-wrap-new .popup-top-total-wrap .car-num .num {
    width: 26.67vw;
    height: 6.4vw;
    line-height: 6.4vw;
    font-size: 3.33vw;
    color: #fff;
    margin-left: 2.8vw;
  }

  .goods-content-wrap-new .popup-top-total-wrap .folder {
    left: 45.87vw;
    width: 8.27vw;
    height: 6.13vw;
  }

  .goods-content-wrap-new .popup-top-total-wrap .cancel-btn {
    width: 20vw;
    height: 7vw;
    line-height: 7vw;

    font-size: 2.67vw;
    margin: 3.13vw 5.87vw 0 0;
  }

  .goods-content-wrap-new .flex-list .img-layer2 {
    bottom: -0.4vw;

    height: 5.47vw;
  }

  .flex-inner::-webkit-scrollbar {
    width: 0.67vw;
    height: 0.67vw;
  }

  // .goods-content-wrap-new .goods-list-content .goods-item.item-sel::after {
  //   content: "";
  //   width: 35.48px;
  //   height: 23.52px;
  //   position: absolute;
  //   top: 11.07vw;
  //   right: 0;
  //   background: url("../../assets/images/k30.png") no-repeat center / 35.48px 23.52px;
  // }

  .goods-content-wrap-new .goods-list-content .goods-item .wear-degree {
    top: 9.33vw;
    left: 2.67vw;

    font-size: 2.67vw;
  }

  .goods-content-wrap-new .goods-list-content .goods-item .name {
    bottom: 10.4vw;

    height: 4vw;
    font-size: 2.67vw;

    padding: 0 2vw 0;
  }

  .goods-content-wrap-new .goods-list-content .goods-item .bottom-info {
    height: 10vw;
    font-size: 3.33vw;
  }

  .goods-content-wrap-new .goods-list-content .goods-item .bottom-info .price {
    height: 4vw;
    line-height: 4vw;

    margin: 1.73vw 0 0 0;
  }

  .goods-content-wrap-new
    .goods-list-content
    .goods-item
    .bottom-info
    .price
    .icon {
    width: 4.27vw;
    height: 4.27vw;
    margin-right: 0.67vw;
  }

  .goods-content-wrap-new .goods-list-content .goods-item .copy-ic {
    top: 1.33vw;
    right: 2vw;
    width: 4.27vw;
    height: 4.53vw;
  }

  .goods-content-wrap-new .goods-list-content .goods-item .check-img {
    top: 1.33vw;
    left: 1.33vw;
    width: 3.2vw;
    height: 3.2vw;
  }

  .goods-content-wrap-new .goods-list-content .empty {
    padding-top: 26.67vw;
  }

  .goods-content-wrap-new .cat-box {
    margin: 7.47vw 0 0 5.87vw;
  }

  .goods-content-wrap-new .cat-icon {
    position: relative;
    width: 10.27vw;
    height: 10.27vw;
  }

  .goods-content-wrap-new .cat-icon .cat-num-box {
    position: absolute;
    left: 6.67vw;
    top: -1.33vw;
    width: 5.07vw;
    height: 5.07vw;
    line-height: 5.07vw;
    -webkit-border-radius: 2.53vw;
    border-radius: 2.53vw;
  }

  .goods-content-wrap-new .shop-bottom-bar-wrap .total-price {
    height: 10.67vw;

    padding-left: 2.67vw;

    margin: 7.07vw 0 0 2vw;
  }

  .goods-content-wrap-new .shop-bottom-bar-wrap .total-price .bi-icon {
    width: 6.27vw;
    height: 6.27vw;
    margin-right: 1.07vw;
  }

  .goods-content-wrap-new .shop-bottom-bar-wrap .total-price .price-num {
    font-size: 4.4vw;
  }

  .goods-content-wrap-new .shop-bottom-bar-wrap .buy-btn {
    width: 42.8vw;
    height: 12.93vw;
    line-height: 12.93vw;
    font-size: 4vw;
    margin: 5.47vw 5.87vw 0 0;
  }

  .filter-btn {
    width: 42vw;
    height: 8vw;
    background-size: 42vw 8vw;
  }
}
</style>
